import { URL_HUB_SIGN } from 'Data/constants.js'

export function getSignatureRequestUrl(id) {
  return `${URL_HUB_SIGN}/${id}`
}
